import { gql } from "@apollo/client";


export const AJUSTAR_FECHA_HASTA_PRIMERA_CONEXION = gql`
    mutation ajustarFechaHastaPrimeraConexion( $idEvaluacion: Int!){
        ajustarFechaHastaPrimeraConexion( idEvaluacion: $idEvaluacion)
 }
`;